import { defineFetch } from 'resift';

const makeGetAuthenticationInfo = defineFetch({
  displayName: 'Get Authentication Info',
  make: personId => ({
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: `/people/${personId}/authentication-info`,
      }),
  }),
});

export default makeGetAuthenticationInfo;
